"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// This may seem foolish but I think it affords a layer of 
// security between implementation changes and API impacts
var defineByConfig = function defineByConfig(_ref) {
  var sequence = _ref.sequence,
      handler = _ref.handler,
      whenTyping = _ref.whenTyping;
  return build(sequence, handler, whenTyping);
};

var build = function build(sequence, handler, whenTyping) {
  return {
    handler: handler,
    sequence: sequence,
    whenTyping: whenTyping !== false
  };
};

var defineShortcut = exports.defineShortcut = function defineShortcut(argOne) {
  // need to check for length in case ArgOne is an array
  if (argOne instanceof Object && argOne.length === undefined) {
    return defineByConfig(argOne);
  }
  return build.apply(null, Array.from(arguments));
};